import React, { Component } from "react";
import { displayErrorMessage } from "@clearabee/ui-library-base";
import { DefaultErrorComponent } from "./DefaultErrorComponent";
/**
 * @param FallbackComponent - Accepts a functional component with children and onRetry as props
 */
export class ErrorBoundary extends Component {
    state = {
        hasError: false,
        message: "",
        key: 0,
    };
    static getDerivedStateFromError() {
        return {
            hasError: true,
            message: "",
            key: 0,
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
        this.setState({ message: errorInfo.componentStack });
    }
    render() {
        const { FallbackComponent } = this.props;
        if (this.state.hasError && FallbackComponent) {
            return (React.createElement(React.Fragment, { key: this.state.key }, displayErrorMessage(this.state.message, ({ children }) => (React.createElement(FallbackComponent, { onRetry: () => {
                    this.setState({
                        hasError: false,
                        key: this.state.key + 1,
                    });
                } }, children)))));
        }
        if (this.state.hasError) {
            return displayErrorMessage(this.state.message, ({ children }) => (React.createElement(DefaultErrorComponent, { onRetry: () => {
                    this.setState({
                        hasError: false,
                        key: this.state.key + 1,
                    });
                } }, children)));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map